export default __webpack_public_path__ + "static/Houston-e72a187a9307740188a64c3792e85a16.svg";